import React from 'react';
import {ContainerFileDinhKem} from 'components/upload';
import { connect } from 'react-redux';
import { Dialog } from "@blueprintjs/core";
import {
  DropDownChonKetLuanNoiDungKhieuNai,
  DropDownChonKetQuaThucHien,
  DropDownKetQuaGiaiQuyetDon,
  DropDownChonCoQuanDieuTra,
  DropDownMulipleUse,
  DropDownNguoiKy
} from 'components/tt-forms';
import { msg } from 'constants/message';
import moment from 'moment';
import { GiaiQuyetDonThu } from 'api';
import { Link, browserHistory } from 'react-router';
import { ShowIf, ShowIfCheck } from 'components/utils';
import { TextArea, DatePicker, Input, InputNumber, Text, TextMessage, DropDownTreeSelectOneElement } from 'components/tt-forms/common';
import { Toastr } from 'modules/toastr';
import ConfirmDialog from './ConfirmDialog.jsx';
import { getParams
} from 'modules/giai-quyet-don/subView/GetParams.jsx';

const loaiTepDinhKem = 'QUYET_DINH';
const loaiQuyTrinh = 'GIAI_QUYET_DON';

class LapDuThaoDonKhieuNaiCanBo extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      id: this.props.id,
      isValid: false,
      btnLoading: false,
      btnSaveLoading: false,
      openDialogLuuHoSo: false,
      openDialogGiaoDoiThoai: false,
      open: false,
      onSave: false,
      loaiDon: this.props.loaiDon,

      valueKetQua: '',

      giaoCoQuanDieuTra: false,
      theoDoiThucHien: false,
      khoiTo: false,
      showTienDoGiaiQuyet: false,

      ketQuaXLDGiaiQuyet: '',

      donViThamTraXacMinh: '',
      ngayHetHanTTXM: '',

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: {
        quyetDinhGiaiQuyet: [],
        giaoCoQuanDieuTra: [],
        giaHan: [],
        data: []
      },
      dataTaiLieuVanThuDelete: [],
      taiLieuVanThuGiaoCoQuanDieuTra: [],
      nextState: 'KET_THUC',
      thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,

      coQuanDieuTra: '',
      soVuGiaoCoQuanDieuTra: '',
      soDoiTuongGiaoCoQuanDieuTra: '',

      tienPhaiThuNhaNuoc: '',
      datPhaiThuNhaNuoc: '',
      tienPhaiTraCongDan: '',
      datPhaiTraCongDan: '',

      tongSoNguoiXuLyHanhChinh: '',
      soNguoiDaBiXuLyHanhChinh: '',

      hinhThucTheoDoi: '',
      coQuanTheoDoi: '',
      ketQuaThucHienTheoDoi: '',

      soVuBiKhoiTo: '',
      soDoiTuongBiKhoiTo: '',

      tienDaThuNhaNuoc: '',
      datDaThuNhaNuoc: '',
      tienDaTraCongDan: '',
      datDaTraCongDan: '',

      soVuGiaiQuyetKhieuNai: '',

      soLanGiaiQuyetLai: '',
      ketQuaGiaiQuyetLan2: '',
      noiDungKetLuanGiaiQuyetLai: '',

      ketQuaGiaiQuyetKhac: '',
      ketQuaThucHienKhac: '',

      allowAttach: false,
      allowAttachGiaoCoQuanDieuTra: false,

      doiThoai: false,
      thoiGianDoiThoai: '',
      diaDiemDoiThoai: '',

      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: [],
      dataDonViTheoDoi: [],
      dataKetQuaGiaiQuyetDon: [],
      dataCoQuanTheoDoi: [],

      hasChange: false,
      backConfirm: false,
      soVanBan: '',
      ngayBanHanh: '',
      nguoiBanHanh: ''
    }
  }

  componentDidMount() {
    this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
    this.getDonViTheoDoi();
    this.getCoQuanTheoDoiEnumn();
    if (this.props.nhanDuThao == true) {
      this.getKetQuaGiaiQuyetDon();
    }
    if (window.debug) {
      console.log('handle-letters/xu-ly-don/form-giai-quyet/chuyen-vien/LapDuThaoDonKhieuNaiCanBo');
    }
  }

  getCoQuanTheoDoiEnumn() {
    GiaiQuyetDonThu.actions.getCoQuanTheoDoiEnumn.request().then(res => {
      if (res.data) {
        this.setState({
          dataCoQuanTheoDoi: res.data
        })
      }
    })
  }

  getKetQuaGiaiQuyetDon() {
    let params = {
      khongCoDoiThoai: true,
      loaiDon: this.props.loaiDon
    }
    GiaiQuyetDonThu.actions.getKetQuaGiaiQuyetDon.request(params).then(res => {
      if (res.data) {
        this.setState({
          dataKetQuaGiaiQuyetDon: res.data
        })
      }
    })
  }

  getDonViTheoDoi() {
    GiaiQuyetDonThu.actions.getCoQuanTheoDoi.request().then(res => {
      if (res.data._embedded) {
        this.setState({
          dataDonViTheoDoi: res.data._embedded.coQuanQuanLies
        })
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    if(this.state.thongTinGiaiQuyetDonId != nextProps.thongTinGiaiQuyetDonId && nextProps.thongTinGiaiQuyetDonId) {
      this.setState({
        id: nextProps.id,
        role: nextProps.role,
        thongTinGiaiQuyetDonId: nextProps.thongTinGiaiQuyetDonId,
        coQuanQuanLyId: nextProps.coQuanQuanLyId,
        coQuanQuanLyNguoiDung: nextProps.coQuanQuanLyNguoiDung
      });
      this.getThongTinGiaiQuyetDon(nextProps.thongTinGiaiQuyetDonId);
    }
  }

  onClickClose(type) {
    if (type == true) {
      browserHistory.goBack()
    } else if (this.state.hasChange) {
      this.setState({
        backConfirm: true
      })
    } else {
      browserHistory.goBack()
    }
  }

  closeConfirmBack() {
    this.setState({
      backConfirm: false
    })
  }

  hasChange() {
    this.setState({
      hasChange: true
    })
  }

  getThongTinGiaiQuyetDon(id) {
    if(typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
      let params = {
        id: id
      };
      GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(res => {
        if(res.data) {
          this.setState({
            dataGiaiQuyetDon: res.data,
            nextState: 'KET_THUC',

            ketLuanNoiDungKhieuNai: res.data.ketLuanNoiDungKhieuNai ? res.data.ketLuanNoiDungKhieuNai : res.data.ketLuanNoiDungKhieuNaiGiaoTTXM,

            doiThoai: res.data.doiThoai,
            thoiGianDoiThoai: res.data.thoiGianDoiThoai ? new Date(res.data.thoiGianDoiThoai) : '',
            diaDiemDoiThoai: res.data.diaDiemDoiThoai,

            coQuanDieuTra: res.data.coQuanDieuTraInfo ? res.data.coQuanDieuTraInfo.coQuanQuanLyId : '',
            soVuGiaoCoQuanDieuTra: res.data.soVuGiaoCoQuanDieuTra ? res.data.soVuGiaoCoQuanDieuTra : 0,
            soDoiTuongGiaoCoQuanDieuTra: res.data.soDoiTuongGiaoCoQuanDieuTra ? res.data.soDoiTuongGiaoCoQuanDieuTra : 0,

            tienPhaiThuNhaNuoc: res.data.tienPhaiThuNhaNuoc ? res.data.tienPhaiThuNhaNuoc : 0,
            datPhaiThuNhaNuoc: res.data.datPhaiThuNhaNuoc ? res.data.datPhaiThuNhaNuoc : 0,
            tienPhaiTraCongDan: res.data.tienPhaiTraCongDan ? res.data.tienPhaiTraCongDan : 0,
            datPhaiTraCongDan: res.data.datPhaiTraCongDan ? res.data.datPhaiTraCongDan : 0,
            tongSoNguoiXuLyHanhChinh: res.data.tongSoNguoiXuLyHanhChinh ? res.data.tongSoNguoiXuLyHanhChinh : 0,
            soNguoiDaBiXuLyHanhChinh: res.data.soNguoiDaBiXuLyHanhChinh ? res.data.soNguoiDaBiXuLyHanhChinh : 0,

            hinhThucTheoDoi: res.data.hinhThucTheoDoi ? res.data.hinhThucTheoDoi : '',
            coQuanTheoDoi: res.data.coQuanTheoDoi ? res.data.coQuanTheoDoi : '',
            ketQuaThucHienTheoDoi: res.data.ketQuaThucHienTheoDoi ? res.data.ketQuaThucHienTheoDoi : '',

            khoiTo: res.data.khoiTo,
            soVuBiKhoiTo: res.data.soVuBiKhoiTo ? res.data.soVuBiKhoiTo : 0,
            soDoiTuongBiKhoiTo: res.data.soDoiTuongBiKhoiTo ? res.data.soDoiTuongBiKhoiTo : 0,

            tienDaThuNhaNuoc: res.data.tienDaThuNhaNuoc ? res.data.tienDaThuNhaNuoc : 0,
            datDaThuNhaNuoc: res.data.datDaThuNhaNuoc ? res.data.datDaThuNhaNuoc : 0,
            tienDaTraCongDan: res.data.tienDaTraCongDan ? res.data.tienDaTraCongDan : 0,
            datDaTraCongDan: res.data.datDaTraCongDan ? res.data.datDaTraCongDan : 0,

            giaoCoQuanDieuTra: res.data.giaoCoQuanDieuTra,
            quyetDinhGiaiQuyetKhieuNai: res.data.quyetDinhGiaiQuyetKhieuNai,
            theoDoiThucHien: res.data.theoDoiThucHien,

            soVanBan: res.data.soVanBan ? res.data.soVanBan : '',
            ngayBanHanh: res.data.ngayBanHanh ? new Date(res.data.ngayBanHanh) : '',
            nguoiBanHanh: res.data.nguoiBanHanhInfo ? res.data.nguoiBanHanhInfo.congChucId : '',

            tienPhaiThuNhaNuocQDGQ: res.data.tienPhaiThuNhaNuocQDGQ ? res.data.tienPhaiThuNhaNuocQDGQ : 0,
            tienPhaiTraCongDanQDGQ: res.data.tienPhaiTraCongDanQDGQ ? res.data.tienPhaiTraCongDanQDGQ : 0,
            datPhaiThuNhaNuocQDGQ: res.data.datPhaiThuNhaNuocQDGQ ? res.data.datPhaiThuNhaNuocQDGQ : 0,
            datPhaiTraCongDanQDGQ: res.data.datPhaiTraCongDanQDGQ ? res.data.datPhaiTraCongDanQDGQ : 0,
            soNguoiDuocTraLaiQuyenLoi: res.data.soNguoiDuocTraLaiQuyenLoi ? res.data.soNguoiDuocTraLaiQuyenLoi : 0,

            soVuGiaiQuyetKhieuNai: res.data.soVuGiaiQuyetKhieuNai ? res.data.soVuGiaiQuyetKhieuNai : 0,
            ketQuaXLDGiaiQuyet: res.data.ketQuaXLDGiaiQuyet ? res.data.ketQuaXLDGiaiQuyet : '',
            showTienDoGiaiQuyet: (res.data.ketQuaXLDGiaiQuyet && res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') ? true : false,

            soLanGiaiQuyetLai: res.data.soLanGiaiQuyetLai ? res.data.soLanGiaiQuyetLai : 0,
            ketQuaGiaiQuyetLan2: res.data.ketQuaGiaiQuyetLan2 ? res.data.ketQuaGiaiQuyetLan2 : '',
            noiDungKetLuanGiaiQuyetLai: res.data.noiDungKetLuanGiaiQuyetLai ? res.data.noiDungKetLuanGiaiQuyetLai : '',

            ketQuaGiaiQuyetKhac: res.data.ketQuaGiaiQuyetKhac ? res.data.ketQuaGiaiQuyetKhac : '',
            ketQuaThucHienKhac: res.data.ketQuaThucHienKhac ? res.data.ketQuaThucHienKhac : '',
            noiDungDoiThoai: res.data.noiDungDoiThoai ? res.data.noiDungDoiThoai : '',
            noiDungGiaoLapDuThao: res.data.noiDungGiaoLapDuThao ? res.data.noiDungGiaoLapDuThao : ''
          }, ()=> {
            this.renderAttachFile();
            this.getNgayHetHanLapDuThao();
            this.checkFileCoQuanDieuTra();
          })
        }
      });
    }
  }

  checkFileCoQuanDieuTra() {
    this.setState({
      allowAttachGiaoCoQuanDieuTra: false
    }, () => {
      if (this.state.giaoCoQuanDieuTra == false) {
        this.setState({
          allowAttachGiaoCoQuanDieuTra: true
        })
      } else {
        let taiLieuVanThuGiaoCoQuanDieuTra = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra];
        let data = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra];
        let dataCheck = data.filter(state => {
          return state.required && state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA'
        });

        if (dataCheck.length > 0) {
          this.setState({
            taiLieuVanThuGiaoCoQuanDieuTra: taiLieuVanThuGiaoCoQuanDieuTra,
            allowAttachGiaoCoQuanDieuTra: true
          })
        } else {
          let newItem = {
            ten: 'Văn bản về việc chuyển hồ sơ sang cơ quan điều tra',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: 'GIAO_CO_QUAN_DIEU_TRA',
            newFile: true
          }
          this.setState({
            taiLieuVanThuGiaoCoQuanDieuTra: [
              ...taiLieuVanThuGiaoCoQuanDieuTra,
              newItem
            ],
            allowAttachGiaoCoQuanDieuTra: true
          })
        }
      }
    })
  }

  getNgayHetHanLapDuThao() {
    GiaiQuyetDonThu.actions.getNgayHetHanLapDuThao.request().then(res => {
      if(res.data) {
        this.setState({
          ngayHetHanGiaoLapDuThao: res.data
        })
      } else {
        this.setState({
          ngayHetHanGiaoLapDuThao: ''
        })
      }
    })
  }

  resetData() {
    this.setState({
      thoiGianDoiThoai:'',
      diaDiemDoiThoai:'',

      coQuanDieuTra:'',
      soVuGiaoCoQuanDieuTra: 0,
      soDoiTuongGiaoCoQuanDieuTra: 0,

      tienPhaiThuNhaNuoc: 0,
      datPhaiThuNhaNuoc: 0,
      tienPhaiTraCongDan: 0,
      datPhaiTraCongDan: 0,
      tongSoNguoiXuLyHanhChinh: 0,
      soNguoiDaBiXuLyHanhChinh: 0,

      hinhThucTheoDoi:'',
      coQuanTheoDoi:'',
      ketQuaThucHienTheoDoi:'',

      soVanBan: '',
      ngayBanHanh: '',
      nguoiBanHanh: '',

      khoiTo:false,
      soVuBiKhoiTo: 0,
      soDoiTuongBiKhoiTo: 0,

      tienDaThuNhaNuoc: 0,
      datDaThuNhaNuoc: 0,
      tienDaTraCongDan: 0,
      datDaTraCongDan: 0,

      giaoCoQuanDieuTra:false,
      quyetDinhGiaiQuyetKhieuNai:false,
      theoDoiThucHien:false,

      tienPhaiThuNhaNuocQDGQ: 0,
      tienPhaiTraCongDanQDGQ: 0,
      datPhaiThuNhaNuocQDGQ: 0,
      datPhaiTraCongDanQDGQ: 0,
      soNguoiDuocTraLaiQuyenLoi: 0,

      soVuGiaiQuyetKhieuNai: 0,

      soLanGiaiQuyetLai: 0,
      ketQuaGiaiQuyetLan2:'',
      noiDungKetLuanGiaiQuyetLai:'',

      ketQuaGiaiQuyetKhac:'',
      ketQuaThucHienKhac:'',
      noiDungDoiThoai:'',
      noiDungGiaoLapDuThao:'',
    }, ()=> {
      this.renderAttachFile();
      this.getNgayHetHanLapDuThao();
    })

  }

  handleChangeDate(name, e) {
    this.hasChange();
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }

  onChange(name, e) {
    this.hasChange();
    if (name == 'ketQuaXLDGiaiQuyet' && e.target.value == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
      this.setState({
        open: true,
        allowAttach: false,
        valueKetQua: e.target.value
      })
      this.resetData();
    } else {
      this.setState({
        [name]: e.target.value,
        valueKetQua: ''
      });

      if(name == 'ketQuaXLDGiaiQuyet') {
        this.resetData();
      }

      if (name == 'ketQuaXLDGiaiQuyet' || name == 'nextState' || name == 'hinhThucTheoDoi' || name == 'soLanGiaiQuyetLai' || name == 'ketQuaGiaiQuyetLan2') {

      }

      if (name == 'soLanGiaiQuyetLai' && Number(e.target.value) <= 1) {
        this.setState({
          ketQuaGiaiQuyetLan2: ''
        })
      }

      if (name == 'ketQuaGiaiQuyetLan2' && Number(e.target.value) != 'HUY_SUA_QDGQ_LAN_I') {
        this.setState({
          noiDungKetLuanGiaiQuyetLai: ''
        })
      }
    }
    if (name=='ketQuaXLDGiaiQuyet') {
      this.setState({
        allowAttach: false
      },()=> {
        this.renderAttachFile();
      })
    }
  }

  onFileChange(data, type) {
    this.hasChange();
    let dataFileDinhKem = {...this.state.dataFileDinhKem};
    if (type == 'QUYET_DINH_GIAI_QUYET') {
      dataFileDinhKem.quyetDinhGiaiQuyet = data;
      let fileQD = data.filter(item => {
        return item.typeRequired == 'QDGQ_LDT'
      });
      this.setState ({ngayBanHanh: fileQD.length ? fileQD[0].ngayQuyetDinh : ''});
    } else if (type == 'GIAO_CO_QUAN_DIEU_TRA') {
      dataFileDinhKem.giaoCoQuanDieuTra = data;
    } else if (type == 'GIA_HAN') {
      dataFileDinhKem.giaHan = data;
    } else {
      dataFileDinhKem.data = data;
    }
    this.setState ({
      dataFileDinhKem: dataFileDinhKem
    });
  }

  onFileRemove(id, data, type) {
    this.hasChange();
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    });

    if (type == 'QUYET_DINH_GIAI_QUYET') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.quyetDinhGiaiQuyet = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else if (type == 'GIAO_CO_QUAN_DIEU_TRA') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.giaoCoQuanDieuTra = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else if (type == 'GIA_HAN') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.giaHan = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.data = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    }

  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  componentWillUnmount() {

  }

  getParams() {
    let dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
    let params = getParams(dataGiaiQuyetDon, this.state.id);

    if(this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
      params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
      params.ngayBanHanh = this.state.ngayBanHanh ? moment(this.state.ngayBanHanh).add(7, 'hours').toISOString() : null;
      params.nguoiBanHanh = this.state.nguoiBanHanh ? {id: this.state.nguoiBanHanh} : null;

      if(this.state.giaoCoQuanDieuTra) {
        params.giaoCoQuanDieuTra = true;
        if (this.state.coQuanDieuTra) {
          params.coQuanDieuTra =  {
            id: Number(this.state.coQuanDieuTra)
          }
        }
        params.soVuGiaoCoQuanDieuTra = Number(this.state.soVuGiaoCoQuanDieuTra);
        params.soDoiTuongGiaoCoQuanDieuTra = Number(this.state.soDoiTuongGiaoCoQuanDieuTra);

        if (this.state.khoiTo) {
          params.khoiTo = true;
          params.soVuBiKhoiTo = this.state.soVuBiKhoiTo;
          params.soDoiTuongBiKhoiTo = this.state.soDoiTuongBiKhoiTo;
        } else {
          params.khoiTo = false;
          params.soVuBiKhoiTo = 0;
          params.soDoiTuongBiKhoiTo = 0;
        }
      } else {
        params.giaoCoQuanDieuTra = false;
        params.coQuanDieuTra = null;
        params.soVuGiaoCoQuanDieuTra = 0;
        params.soDoiTuongGiaoCoQuanDieuTra = 0;

        params.khoiTo = false;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;
      }

      if(this.state.theoDoiThucHien) {
        params.theoDoiThucHien = true;
        params.hinhThucTheoDoi = this.state.hinhThucTheoDoi;
        if (this.state.coQuanTheoDoi && this.state.hinhThucTheoDoi == 'GIAO_CO_QUAN_KHAC_THEO_DOI') {
          params.coQuanTheoDoi = this.state.coQuanTheoDoi
        } else {
          params.coQuanTheoDoi = null
        }

        params.ketQuaThucHienTheoDoi = this.state.ketQuaThucHienTheoDoi;
        params.soVuBiKhoiTo = Number(this.state.soVuBiKhoiTo);
        params.soDoiTuongBiKhoiTo = Number(this.state.soDoiTuongBiKhoiTo);
        params.tienDaThuNhaNuoc = Number(this.state.tienDaThuNhaNuoc);
        params.datDaThuNhaNuoc = Number(this.state.datDaThuNhaNuoc);
        params.tienDaTraCongDan = Number(this.state.tienDaTraCongDan);
        params.datDaTraCongDan = Number(this.state.datDaTraCongDan);

        params.tienPhaiThuNhaNuoc = Number(this.state.tienPhaiThuNhaNuoc);
        params.datPhaiThuNhaNuoc = Number(this.state.datPhaiThuNhaNuoc);
        params.tienPhaiTraCongDan = Number(this.state.tienPhaiTraCongDan);
        params.datPhaiTraCongDan = Number(this.state.datPhaiTraCongDan);

        params.ketQuaThucHienKhac = this.state.ketQuaThucHienKhac;

      } else {
        params.theoDoiThucHien = false;
        params.hinhThucTheoDoi = null;
        params.coQuanTheoDoi = null
        params.ketQuaThucHienTheoDoi = null;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;
        params.tienDaThuNhaNuoc = 0;
        params.datDaThuNhaNuoc = 0;
        params.tienDaTraCongDan = 0;
        params.datDaTraCongDan = 0;

        params.tienPhaiThuNhaNuoc = 0;
        params.datPhaiThuNhaNuoc = 0;
        params.tienPhaiTraCongDan = 0;
        params.datPhaiTraCongDan = 0;

        params.ketQuaThucHienKhac = '';
      }

      params.quyetDinhGiaiQuyetKhieuNai = true;
      params.ketQuaGiaiQuyetKhac = this.state.ketQuaGiaiQuyetKhac;

      params.soLanGiaiQuyetLai = Number(this.state.soLanGiaiQuyetLai);

      if (Number(this.state.soLanGiaiQuyetLai) > 1) {
        params.ketQuaGiaiQuyetLan2 = this.state.ketQuaGiaiQuyetLan2 ? this.state.ketQuaGiaiQuyetLan2 : null;
      } else {
        params.ketQuaGiaiQuyetLan2 = null;
      }

      if ((this.state.ketQuaGiaiQuyetLan2 == 'HUY_SUA_QDGQ_LAN_I') && (Number(this.state.soLanGiaiQuyetLai) > 1)) {
        params.noiDungKetLuanGiaiQuyetLai = this.state.noiDungKetLuanGiaiQuyetLai;
      } else {
        params.noiDungKetLuanGiaiQuyetLai = '';
      }

      params.tienPhaiThuNhaNuocQDGQ = Number(this.state.tienPhaiThuNhaNuocQDGQ);
      params.tienPhaiTraCongDanQDGQ = Number(this.state.tienPhaiTraCongDanQDGQ);
      params.datPhaiThuNhaNuocQDGQ = Number(this.state.datPhaiThuNhaNuocQDGQ);
      params.datPhaiTraCongDanQDGQ = Number(this.state.datPhaiTraCongDanQDGQ);

      params.soVuGiaiQuyetKhieuNai = Number(this.state.soVuGiaiQuyetKhieuNai);
      params.ketLuanNoiDungKhieuNai = this.state.ketLuanNoiDungKhieuNai ? this.state.ketLuanNoiDungKhieuNai : null;
      params.tongSoNguoiXuLyHanhChinh = Number(this.state.tongSoNguoiXuLyHanhChinh);
      params.soNguoiDaBiXuLyHanhChinh = Number(this.state.soNguoiDaBiXuLyHanhChinh);
      params.soNguoiDuocTraLaiQuyenLoi = Number(this.state.soNguoiDuocTraLaiQuyenLoi);
    } else {
      params.giaoCoQuanDieuTra = false;
      params.coQuanDieuTra = null;
      params.soVuGiaoCoQuanDieuTra = 0;
      params.soDoiTuongGiaoCoQuanDieuTra = 0;

      params.theoDoiThucHien = false;
      params.hinhThucTheoDoi = null;
      params.coQuanTheoDoi = null
      params.ketQuaThucHienTheoDoi = null;
      params.soVuBiKhoiTo = 0;
      params.soDoiTuongBiKhoiTo = 0;
      params.tienDaThuNhaNuoc = 0;
      params.datDaThuNhaNuoc = 0;
      params.tienDaTraCongDan = 0;
      params.datDaTraCongDan = 0;

      params.tienPhaiThuNhaNuoc = 0;
      params.datPhaiThuNhaNuoc = 0;
      params.tienPhaiTraCongDan = 0;
      params.datPhaiTraCongDan = 0;

      params.ketQuaThucHienKhac = '';

      params.khoiTo = false;
      params.soVuBiKhoiTo = 0;
      params.soDoiTuongBiKhoiTo = 0;

      params.quyetDinhGiaiQuyetKhieuNai = false;

      params.soLanGiaiQuyetLai = 0;
      params.ketQuaGiaiQuyetKhac = '';

      params.ketQuaGiaiQuyetLan2 = null;
      params.noiDungKetLuanGiaiQuyetLai = '';

      params.tienPhaiThuNhaNuocQDGQ = 0;
      params.tienPhaiTraCongDanQDGQ = 0;
      params.datPhaiThuNhaNuocQDGQ = 0;
      params.datPhaiTraCongDanQDGQ = 0;

      params.soVuGiaiQuyetKhieuNai = 0;
      params.ketLuanNoiDungKhieuNai = null;
      params.tongSoNguoiXuLyHanhChinh = 0;
      params.soNguoiDaBiXuLyHanhChinh = 0;

      params.soNguoiDuocTraLaiQuyenLoi = 0;
    }

    params.ketQuaXLDGiaiQuyet = this.state.ketQuaXLDGiaiQuyet ? this.state.ketQuaXLDGiaiQuyet : null;

    if (this.state.ketQuaXLDGiaiQuyet == 'DOI_THOAI') {
      params.doiThoai = true;
      params.thoiGianDoiThoai = this.state.thoiGianDoiThoai ? moment(this.state.thoiGianDoiThoai).add(7, 'hours').toISOString() : null;
      params.diaDiemDoiThoai = this.state.diaDiemDoiThoai;
      params.noiDungDoiThoai = this.state.noiDungDoiThoai;
      params.noiDungGiaoLapDuThao = this.state.noiDungGiaoLapDuThao;
      params.ngayHetHanGiaoLapDuThao = this.state.ngayHetHanGiaoLapDuThao;
    } else if (this.props.nhanDuThao != true) {
      params.doiThoai = false;
      params.thoiGianDoiThoai = null;
      params.diaDiemDoiThoai = '';
      params.noiDungDoiThoai = '';
      params.noiDungGiaoLapDuThao = '';
      params.ngayHetHanGiaoLapDuThao = null;
    }

    return params;
  }

  handleSave() {
    this.setState({
      onSave: true
    }, ()=> {
      if (this.validateSubmitForm()) {
        this.setState({
          btnLoading: true,
          btnSaveLoading: true
        });
        let dataFileDinhKem = this.getListDataFileDinhKem();

        if (dataFileDinhKem.length > 0) {
          dataFileDinhKem.map((item, i) => {
            if (item.taiLieuVanThuId) {
              this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(this.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(this.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: loaiQuyTrinh,
                buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });
        }

        if (this.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET') {
          let dataFile = [...this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ]
          dataFile.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        if (!this.state.giaoCoQuanDieuTra) {
          let dataFile = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra]
          dataFile.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        if (this.state.dataTaiLieuVanThuDelete.length > 0) {
          this.state.dataTaiLieuVanThuDelete.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        let params = this.getParams();
        this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
          this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
            this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
              this.saveGiaiQuyetDon(params, 'gqdLuu');
            });
          });
        });
      }
    })
  }

  handleKetThuc(type) {
    this.setState({
      onSave: false
    }, ()=> {
      if (this.validateSubmitForm()) {
        this.setState({
          btnLoading: true
        });
        let dataFileDinhKem = this.getListDataFileDinhKem();

        if (dataFileDinhKem.length > 0) {
          dataFileDinhKem.map((item, i) => {
            if (item.taiLieuVanThuId) {
              this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(this.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(this.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: loaiQuyTrinh,
                buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });
        }

        if (this.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET') {
          let dataFile = [...this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ]
          dataFile.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        if (!this.state.giaoCoQuanDieuTra) {
          let dataFile = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra]
          dataFile.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        if (this.state.dataTaiLieuVanThuDelete.length > 0) {
          this.state.dataTaiLieuVanThuDelete.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        let _params = this.getParams();
        let params = {};
        let msgName = '';

        if (this.props.tuGiaiQuyet == true) {
          if (this.props.nhanDuThao == true) {
            params = {
              thongTinGiaiQuyetDon: {
                id: Number(this.props.thongTinGiaiQuyetDonId)
              },
              actionType: 'GQD_NHAN_DU_THAO'
            }
            msgName = 'gqdLuuHoSo';
          } else {
            if (type == 'luuHoSo') {
              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(this.props.thongTinGiaiQuyetDonId)
                },
                actionType: 'GQD_NHAN_BAO_CAO_TTXM'
              }
              msgName = 'gqdLuuHoSo';
              this.updateGiaiQuyetDon(_params, params, 'gqdLuuHoSo');
            } else {
              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(this.props.thongTinGiaiQuyetDonId)
                },
                actionType: 'GQD_NHAN_BAO_CAO_TTXM_GUI_DU_THAO'
              }
              msgName = 'gqdGuiDuThao';
            }
          }

        } else {
          if (type == 'luuHoSo') {
            let selectedState = this.props.dataNextStates.filter(state => {
              return state.type == 'KET_THUC'
            });

            params = {
              thongTinGiaiQuyetDon: {
                id: Number(this.props.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              }
            }
            msgName = 'gqdLuuHoSo';
          } else {
            let selectedState = this.props.dataNextStates.filter(state => {
              return state.type == 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO'
            });

            params = {
              thongTinGiaiQuyetDon: {
                id: Number(this.props.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              yKienGiaiQuyet: this.state.noiDungGiaoLapDuThao ? this.state.noiDungGiaoLapDuThao : ''
            }
            msgName = 'gqdGuiDuThao';
          }
        }
        this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
          this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
            this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
              this.updateGiaiQuyetDon(_params, params, msgName);
            });
          });
        });
      }
    })
  }

  updateGiaiQuyetDon(params, _params, message) {
    GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({id: this.state.thongTinGiaiQuyetDonId},params).then(res => {
      this.postGiaiQuyetDon(_params, message);
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  saveGiaiQuyetDon(params, message) {
    GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({id: this.state.thongTinGiaiQuyetDonId},params).then(res => {
      this.onClickClose(true);
      Toastr(message ? msg[message] : msg.luuGiaiQuyetDonThanhCong, 'success');
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  postGiaiQuyetDon(params, message) {
    GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', params).then(res => {
      this.onClickClose(true);
      Toastr(message ? msg[message] : msg.giaiQuyetDon, 'success');
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  getListDataFileDinhKem() {
    let dataFileDinhKem = []
    let Data = this.state.dataFileDinhKem;

    if (Data.data.length > 0) {
      Data.data.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (Data.quyetDinhGiaiQuyet.length > 0 && this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
      Data.quyetDinhGiaiQuyet.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (Data.giaoCoQuanDieuTra.length > 0 && this.state.giaoCoQuanDieuTra) {
      Data.giaoCoQuanDieuTra.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (Data.giaHan.length > 0 && (this.state.giaHanGiaiQuyet)) {
      Data.giaHan.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    return dataFileDinhKem;
  }

  // Cap nhat tep dinh kem
  updateTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {
        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Them tep dinh kem
  postTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {
        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Xoa tep dinh kem
  deleteTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {
        }
        callback();
      });
    } else {
      callback();
    }
  }

  handleCheck(name, e) {
    this.hasChange();
    this.setState({
      [name]: e
    })
    if (name =='giaoCoQuanDieuTra') {
      this.checkFileCoQuanDieuTra();
    }
    if (!e) {

    }
  }

  handleChange(e) {
    this.hasChange();
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  openDialog(type) {
    if (this.validateSubmitForm()) {
      if(type =='luuHoSo') {
        this.setState({
          openDialogLuuHoSo: true
        })
      } else {
        this.setState({
          openDialogGiaoDoiThoai: true
        })
      }
    }
  }

  closeDialog(type) {
    if(type=='luuHoSo') {
      this.setState({
        openDialogLuuHoSo: false
      })
    } else {
      this.setState({
        openDialogGiaoDoiThoai: false
      })
    }
  }

  onSuccess(type) {
    if(type=='luuHoSo') {
      this.setState({
        openDialogLuuHoSo: false
      })
      this.handleKetThuc('luuHoSo');
    } else {
      this.setState({
        openDialogGiaoDoiThoai: false
      })
      this.handleKetThuc('giaoDoiThoai');
    }
  }

  closeDialogConfirm() {
    this.setState({
      open: false,
      ketQuaXLDGiaiQuyet: this.state.ketQuaXLDGiaiQuyet
    },()=> {
      this.renderAttachFile();
    })

  }

  onSuccessDialogConfirm() {
    this.setState({
      open: false,
      ketQuaXLDGiaiQuyet: this.state.valueKetQua
    },()=> {
      this.renderAttachFile();
    })

  }

  compareDate(firstDate, secondDate, type) {
    var firstTime = firstDate.getTime();
    var secondTime = secondDate.getTime()

    if (firstTime >= secondTime && type == 'show') {
      return true
    } else {
      return false
    }
  }

  renderAttachFile() {
    let DataTaiLieuVanThu = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
    let DataTaiLieuVanThuView = [...this.props.listTaiLieuVanThuGiaiQuyetDon];

    let listTaiLieuVanThuGiaiQuyetDon = [];

    let listTaiLieuVanThuGiaiQuyetDonView = [];

    if(this.props.nhanDuThao == true) {
      listTaiLieuVanThuGiaiQuyetDon = DataTaiLieuVanThu.filter(state => {
        return this.compareDate(new Date(state.ngayTao), new Date(this.state.dataGiaiQuyetDon.ngayKetThucGiaoLapDuThao), 'action');
      })

      listTaiLieuVanThuGiaiQuyetDonView = DataTaiLieuVanThuView.filter(state => {
        return this.compareDate(new Date(this.state.dataGiaiQuyetDon.ngayKetThucGiaoLapDuThao), new Date(state.ngayTao), 'show');
      })
    } else {
      listTaiLieuVanThuGiaiQuyetDon = DataTaiLieuVanThu.filter(state => {
        return this.compareDate(new Date(state.ngayTao), new Date(this.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM), 'action');
      })

      listTaiLieuVanThuGiaiQuyetDonView = DataTaiLieuVanThuView.filter(state => {
        return this.compareDate(new Date(this.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM), new Date(state.ngayTao), 'show');
      })
    }

    if (this.props.nhanDuThao != true) {
      if (this.state.ketQuaXLDGiaiQuyet == 'DOI_THOAI' && this.state.valueKetQua != 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        let data = [...listTaiLieuVanThuGiaiQuyetDon];
        let dataCheck = data.filter(item => {
          return item.required && item.typeRequired == 'BB_DOI_THOAI'
        })
        if (dataCheck.length > 0) {
          //Do nothing
        } else {
          listTaiLieuVanThuGiaiQuyetDon[listTaiLieuVanThuGiaiQuyetDon.length] = {
            ten: 'Biên bản đối thoại',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: 'BB_DOI_THOAI',
            newFile: true
          }
        }
        this.setState({
          listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon,
          listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
          allowAttach: true
        })
      } else {
        this.setState({
          allowAttach: false
        })
        let data = [...listTaiLieuVanThuGiaiQuyetDon];
        let dataForFillter = [...listTaiLieuVanThuGiaiQuyetDon];

        let dataFillter = dataForFillter.filter(item => {
          return item.typeRequired != 'BB_DOI_THOAI'
        })

        let dataCheck = data.filter(item => {
          return item.taiLieuVanThuId && item.typeRequired == 'BB_DOI_THOAI'
        })
        if (dataCheck.length > 0) {
          dataCheck.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          })
        }
        this.setState({
          listTaiLieuVanThuGiaiQuyetDon: dataFillter,
          listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
          allowAttach: true
        })
      }
    } else {
      this.setState({
        listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon,
        listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
        allowAttach: true
      })
    }
  }

  render() {
    let ketQuaGiaiQuyetDon = this.props.ketQuaGiaiQuyetDon.filter(state => {
      return state.giaTri == this.state.ketQuaXLDGiaiQuyet
    });
    let lb1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
    let lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
    return (
      <section className="wrap-block">
        <ConfirmDialog open={this.state.backConfirm}
          onClose={this.closeConfirmBack.bind(this)}
          onSuccess={this.onClickClose.bind(this, true)}
          title='Xác nhận'
          content={msg.confirmBack} />
        <div className="row pl10 pr10">
          <div className="col-100 no-gutter">
            <h3 className="txt-upper title-14 mt0 mb15 pl5 pr5">Báo cáo kết quả xác minh{lb2}</h3>
            <div className="col-100 mb15 no-gutter">
              <Text className="col-25" label={"Đơn vị "+lb1+":"} value={this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo.ten : ''}/>
              <Text className="col-25" red={true} label="Thời gian báo cáo kết quả:" value={this.state.dataGiaiQuyetDon.ngayHetHanTTXM ? moment(this.state.dataGiaiQuyetDon.ngayHetHanTTXM).format('DD/MM/YYYY') : ''}/>
              <Text className="col-25" label="Ngày báo cáo kết quả:" value={this.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM ? moment(this.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM).format('DD/MM/YYYY') : ''}/>
            </div>

            <ShowIf condition={this.props.loaiDon == 'DON_TO_CAO' && this.state.dataGiaiQuyetDon.giaHanGiaiQuyet}>
              <div>
                <div className="col-100">
                  <h3 className="text-12 txt-upper txt-bold mb10 mt0">Gia hạn giải quyết tố cáo</h3>
                </div>
                <Text className="col-25 mb10" red={true} label="Gia hạn đến ngày:" value={this.state.dataGiaiQuyetDon.ngayHetHanSauKhiGiaHanGiaiQuyet ? moment(this.state.dataGiaiQuyetDon.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : ''}/>
                <TextMessage className="col-100 mb5" label="Lý do gia hạn:" value={this.state.dataGiaiQuyetDon.lyDoGiaHanGiaiQuyet ? this.state.dataGiaiQuyetDon.lyDoGiaHanGiaiQuyet : ''}/>
              </div>
            </ShowIf>

            <ShowIf condition={this.props.nhanDuThao == true}>
              <div>
                <div className="col-100 pt5 pb15">
                  <span className="line-border"></span>
                </div>

                <div className="col-100">
                  <div className="col-100 no-gutter mt5 pb10">
                    <h2 className="title-12 mb15">Đối thoại</h2>
                    <div className="row pl10 pr10">
                      <Text className="col-25 mb10" label="Thời gian đối thoại:" value={this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.thoiGianDoiThoai ? moment(this.state.dataGiaiQuyetDon.thoiGianDoiThoai).format('DD/MM/YYYY') : ''}/>
                      <Text className="col-75 mb10" label="Địa điểm:" value={this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.diaDiemDoiThoai ? this.state.dataGiaiQuyetDon.diaDiemDoiThoai : ''}/>
                      <TextMessage className="col-100 mb0-18" label="Nội dung, kết quả đối thoại:" value={this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.noiDungDoiThoai ? this.state.dataGiaiQuyetDon.noiDungDoiThoai : ''}/>
                    </div>
                  </div>
                </div>

                <div className="col-100 pt5 pb15">
                  <span className="line-border"></span>
                </div>

                <div className="col-100">
                  <div className="col-100 no-gutter mt5 pb10">
                    <h2 className="title-12 mb15">Giao dự thảo quyết định giải quyết khiếu nại</h2>
                    <div className="row pl10 pr10">
                      <Text className="col-25 mb10" label="Thời gian trình dự thảo:" red={true} value={this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.ngayHetHanGiaoLapDuThao ? moment(this.state.dataGiaiQuyetDon.ngayHetHanGiaoLapDuThao).format('DD/MM/YYYY') : ''}/>
                      <TextMessage className="col-100 mb0-18" label="Ý kiến xử lý:" value={this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.noiDungGiaoLapDuThao ? this.state.dataGiaiQuyetDon.noiDungGiaoLapDuThao : ''} name='noiDungGiaoLapDuThao'/>
                    </div>
                  </div>
                </div>

                <div className="col-100 pt5 pb15">
                  <span className="line-border"></span>
                </div>

                <div className="col-100">
                  <div className="col-100 no-gutter mt5 pb10">
                    <h2 className="title-12 mb15"> Dự thảo quyết định giải quyết khiếu nại</h2>
                    <div className="row pl10 pr10">
                      <Text className="col-25 mb10" label="Ngày trình dự thảo:" value={this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.ngayKetThucGiaoLapDuThao ? moment(this.state.dataGiaiQuyetDon.ngayKetThucGiaoLapDuThao).format('DD/MM/YYYY') : ''}/>
                      <TextMessage className="col-100 mb0-18" label="Tóm tắt nội dung kết quả đối thoại:" value={this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.noiDungKetLuanDuThao ? this.state.dataGiaiQuyetDon.noiDungKetLuanDuThao : ''}/>
                    </div>
                  </div>
                </div>
              </div>
            </ShowIf>
          </div>
        </div>
        <div className="row pl15 pr15">
          <div className="wrap-big-line pt5 pb20">
            <span className="big-border"></span>
          </div>

          <div className="col-100 no-gutter mt5">
            <h2 className="title-12 mb10">Tiến độ giải quyết</h2>
            <div className="row pl10 pr10">
              <p className="attach-file-description mb10 pl5 pr5">Tiến độ giải quyết cho biết giai đoạn giải quyết hiện tại của đơn</p>
              <ShowIf condition={!this.state.showTienDoGiaiQuyet && this.props.nhanDuThao != true}>
                <DropDownKetQuaGiaiQuyetDon confirm={true} className="col-25" selectedValue={this.state.ketQuaXLDGiaiQuyet} onChange={this.onChange.bind(this, 'ketQuaXLDGiaiQuyet')} loaiDon={this.props.loaiDon}/>
              </ShowIf>
              <ShowIf condition={!this.state.showTienDoGiaiQuyet && this.props.nhanDuThao == true}>
                <DropDownMulipleUse confirm={true} label='' className="col-25" data={this.state.dataKetQuaGiaiQuyetDon} keyName='giaTri' valueName='ten' selectedValue={this.state.ketQuaXLDGiaiQuyet} onChange={this.onChange.bind(this, 'ketQuaXLDGiaiQuyet')}/>
              </ShowIf>
              <ShowIf condition={this.state.showTienDoGiaiQuyet}>
                <Text className="col-25 mb10" label='' value={ketQuaGiaiQuyetDon.length > 0 ? ketQuaGiaiQuyetDon[0].ten : ''}/>
              </ShowIf>
            </div>
          </div>


          <ShowIf condition={this.state.ketQuaXLDGiaiQuyet == 'DOI_THOAI'}>
            <div className="col-100 no-gutter">
              <div className="col-100 no-gutter mt5 pb20">
                <h2 className="title-12 mb15">Đối thoại</h2>
                <div className="row pl10 pr10">
                  <DatePicker className="col-25" require bindValidator={this} channel="formTaoDon" label="Thời gian đối thoại" value={this.state.thoiGianDoiThoai} onChange={this.handleChangeDate.bind(this, 'thoiGianDoiThoai')} name="datepickerThoiGianDoiThoai"/>
                  <Input className="col-75" require bindValidator={this} channel="formTaoDon" label="Địa điểm" value={this.state.diaDiemDoiThoai} onChange={this.onChange.bind(this, 'diaDiemDoiThoai')} name="inputDiaDiem"/>
                  <TextArea className="col-100 mb0-18" require bindValidator={this} channel="formTaoDon" label="Nội dung, kết quả đối thoại" value={this.state.noiDungDoiThoai} onChange={this.onChange.bind(this, 'noiDungDoiThoai')}/>
                </div>
              </div>
            </div>
            <div className="col-100 no-gutter pt5 pb15">
              <span className="line-border"></span>
            </div>
          </ShowIf>

          <ShowIf condition={this.state.ketQuaXLDGiaiQuyet == 'DOI_THOAI'}>
            <div className="col-100 no-gutter">
              <div className="col-100 no-gutter mt5 pb20">
                <h2 className="title-12 mb15">Giao dự thảo quyết định giải quyết khiếu nại</h2>
                <div className="row pl10 pr10">
                  <Text className="col-25 mb10" label="Thời gian trình dự thảo:" value={this.state.ngayHetHanGiaoLapDuThao ?  moment(this.state.ngayHetHanGiaoLapDuThao).format('DD/MM/YYYY') : ''} red={true}/>
                  <TextArea className="col-100 mb0-18" label="Ý kiến xử lý" value={this.state.noiDungGiaoLapDuThao} onChange={this.onChange.bind(this, 'noiDungGiaoLapDuThao')}/>
                </div>
              </div>
            </div>
          </ShowIf>

          <ShowIf condition={this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET'}>
            <div>
              <h3 className="txt-upper title-14 mt0 mb15">Quyết định giải quyết khiếu nại</h3>
              <div className="row pl10 pr10">
                <Input triggeOnBlur={true} name="inputSoVanBan" className="col-25" label="Số văn bản" bindValidator={this} channel="formTaoDon" require value={this.state.soVanBan} onChange={this.onChange.bind(this, 'soVanBan')} maxLength={255}/>
                <DatePicker className="col-25" label="Ngày ban hành" bindValidator={this} endDate={new Date()} channel="formTaoDon" require value={this.state.ngayBanHanh} onChange={this.handleChangeDate.bind(this, 'ngayBanHanh')} name="inputNgayBanHanh"/>
                <DropDownNguoiKy selected={this.state.nguoiBanHanh} onChange={this.onChange.bind(this, 'nguoiBanHanh')} />
                <ShowIf condition={this.state.allowAttach}>
                  <div className="col-100 pt15">
                    <ContainerFileDinhKem loaiVanBanSuggest="QDGQ_LDT" ngayQuyetDinhSuggest={this.state.ngayBanHanh} soVanBanSuggest={this.state.soVanBan} onSave={this.state.onSave} loaiDon={this.state.loaiDon} phanLoaiQuyTrinh='QUYET_DINH_GIAI_QUYET' qDGQText='QDGQ_LDT' qDGQRequired={true} label="Danh sách văn bản xử lý" bindValidator={this} data={this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
                  </div>
                </ShowIf>
              </div>

              <div className="col-100 no-gutter pt10 pb20">
                <span className="line-border"></span>
              </div>

              <div className="row pl10 pr10">
                <InputNumber className="col-25 mb0-18" label="Số vụ" value={Number(this.state.soVuGiaiQuyetKhieuNai)} onChange={this.onChange.bind(this, 'soVuGiaiQuyetKhieuNai')} name="soVuDonToCao"/>
                <DropDownChonKetLuanNoiDungKhieuNai require bindValidator={this} channel="formTaoDon" loaiDon={this.state.loaiDon} label="Kết luận nội dung khiếu nại" className="col-25" selectedValue={this.state.ketLuanNoiDungKhieuNai} onChange={this.onChange.bind(this, 'ketLuanNoiDungKhieuNai')}/>
                <Input className="col-25 mb0-18" label="Kết quả khác" name="ketQuaKhac" value={this.state.ketQuaGiaiQuyetKhac} onChange={this.onChange.bind(this, 'ketQuaGiaiQuyetKhac')}/>
              </div>
              <div className="row pl10 pr10 mb5">
                <div className="col-50 no-gutter mb20">
                  <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi cho nhà nước</p>
                  <Input className="col-50 mb0-18" type="sdt" align="right" label="Phải thu tiền (đ)" value={this.state.tienPhaiThuNhaNuocQDGQ} onChange={this.onChange.bind(this, 'tienPhaiThuNhaNuocQDGQ')} name="tienPhaiThuDonToCao"/>
                  <Input className="col-50 mb0-18" type="sdt" align="right" label="Phải thu đất (m2)" value={this.state.datPhaiThuNhaNuocQDGQ} onChange={this.onChange.bind(this, 'datPhaiThuNhaNuocQDGQ')} name="datPhaiThuDonToCao"/>
                </div>
                <div className="col-50 no-gutter mb20">
                  <p className="txt-bold txt-upper mb10 pl5 pr5">Trả lại cho công dân</p>
                  <Input className="col-50 mb0-18" type="sdt" align="right" label="Phải trả tiền (đ)" value={this.state.tienPhaiTraCongDanQDGQ} onChange={this.onChange.bind(this, 'tienPhaiTraCongDanQDGQ')} name="tienPhaiTraDonToCao"/>
                  <Input className="col-50 mb0-18" type="sdt" align="right" label="Phải trả đất (m2)" value={this.state.datPhaiTraCongDanQDGQ} onChange={this.onChange.bind(this, 'datPhaiTraCongDanQDGQ')} name="datPhaiTraDonToCao"/>
                </div>
                <div className="col-100 no-gutter">
                  <p className="txt-bold txt-upper mb10 pl5 pr5">Xử lý hành chính</p>
                  <InputNumber className="col-25 mb0-18" label="Tổng số người" value={Number(this.state.tongSoNguoiXuLyHanhChinh)} onChange={this.onChange.bind(this, 'tongSoNguoiXuLyHanhChinh')} name="tongSoNguoiXuLyDonToCao"/>
                  <InputNumber className="col-25 mb0-18" label="Số người đã bị xử lý" value={Number(this.state.soNguoiDaBiXuLyHanhChinh)} onChange={this.onChange.bind(this, 'soNguoiDaBiXuLyHanhChinh')} name="soNguoiDaBiXuLyDonToCao"/>
                  <InputNumber className="col-25 mb0-18" label="Số người được trả lại quyền lợi" value={this.state.soNguoiDuocTraLaiQuyenLoi} onChange={this.onChange.bind(this, 'soNguoiDuocTraLaiQuyenLoi')} name="inputnumberSoNguoiTraQuyenLoi"/>
                </div>
              </div>

              <div className="col-100 no-gutter pt5 pb15">
                <span className="line-border"></span>
              </div>

              <div className="col-100 no-gutter">
                <ShowIfCheck label="Theo dõi thực hiện" onChange={this.handleCheck.bind(this, 'theoDoiThucHien')} checked={this.state.theoDoiThucHien} name="checkboxTheoDoiThucHien">
                  <div className="col-100 no-gutter mt5 pb20">
                    <h2 className="title-12 mb15">Theo dõi thực hiện</h2>
                    <div className="row pl10 pr10 mb20">
                      <ShowIf condition={this.state.hinhThucTheoDoi == 'GIAO_CO_QUAN_KHAC_THEO_DOI'}>
                        <DropDownTreeSelectOneElement className="col-25 mb0-18" label="Cơ quan theo dõi" bindValidator={this} channel="formTaoDon" require dataOptions={this.state.dataDonViTheoDoi} value={this.state.coQuanTheoDoi} onChange={this.onChange.bind(this, 'coQuanTheoDoi')} propertyChildren='coQuanQuanLyCha' propertyParent='coQuanQuanLyId'/>
                      </ShowIf>
                    </div>
                    <div className="row pl10 pr10 mb20">
                      <DropDownChonKetQuaThucHien className="col-25 mb0-18" isValid={this.state.isValid} bindValidator={this} require selectedValue={this.state.ketQuaThucHienTheoDoi} onChange={this.onChange.bind(this, 'ketQuaThucHienTheoDoi')}/>
                      <Input className="col-25 mb0-18" label="Kết quả thực hiện khác" value={this.state.ketQuaThucHienKhac} onChange={this.onChange.bind(this, 'ketQuaThucHienKhac')}/>
                    </div>
                    <div className="row pl10 pr10">
                      <div className="col-100 no-gutter mb20">
                        <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi cho nhà nước</p>
                        <Input className="col-25 mb0-18" type="sdt" align="right" label="Phải thu tiền (đ)" value={this.state.tienPhaiThuNhaNuoc} onChange={this.onChange.bind(this, 'tienPhaiThuNhaNuoc')} name="tienPhaiThuTheoDoiThucHien"/>
                        <Input className="col-25 mb0-18" type="sdt" align="right" label="Phải thu đất (m2)" value={this.state.datPhaiThuNhaNuoc} onChange={this.onChange.bind(this, 'datPhaiThuNhaNuoc')} name="datPhaiThuTheoDoiThucHien"/>
                        <Input className="col-25 mb0-18" type="sdt" align="right" label="Đã thu tiền (đ)" value={this.state.tienDaThuNhaNuoc} onChange={this.onChange.bind(this, 'tienDaThuNhaNuoc')} name="tienDaThuTheoDoiThucHien"/>
                        <Input className="col-25 mb0-18" type="sdt" align="right" label="Đã thu đất (m2)" value={this.state.datDaThuNhaNuoc} onChange={this.onChange.bind(this, 'datDaThuNhaNuoc')} name="datDaThuTheoDoiThucHien"/>
                      </div>
                      <div className="col-100 no-gutter">
                        <p className="txt-bold txt-upper mb10 pl5 pr5">Trả lại cho công dân</p>
                        <Input className="col-25 mb0-18" type="sdt" align="right" label="Phải trả tiền (đ)" value={this.state.tienPhaiTraCongDan} onChange={this.onChange.bind(this, 'tienPhaiTraCongDan')} name="tienPhaiTraTheoDoiThucHien"/>
                        <Input className="col-25 mb0-18" type="sdt" align="right" label="Phải trả đất (m2)" value={this.state.datPhaiTraCongDan} onChange={this.onChange.bind(this, 'datPhaiTraCongDan')} name="datPhaiTraTheoDoiThucHien"/>
                        <Input className="col-25 mb0-18" type="sdt" align="right" label="Đã trả tiền (đ)" value={this.state.tienDaTraCongDan} onChange={this.onChange.bind(this, 'tienDaTraCongDan')} name="tienDaTraTheoDoiThucHien"/>
                        <Input className="col-25 mb0-18" type="sdt" align="right" label="Đã trả đất (m2)" value={this.state.datDaTraCongDan} onChange={this.onChange.bind(this, 'datDaTraCongDan')} name="datDaTraTheoDoiThucHien"/>
                      </div>
                    </div>
                  </div>
                </ShowIfCheck>
              </div>

              <div className="col-100 no-gutter pt5 pb15">
                <span className="line-border"></span>
              </div>

              <div className="col-100 no-gutter">
                <ShowIfCheck label="Chuyển cơ quan điều tra(Nếu có)" onChange={this.handleCheck.bind(this, 'giaoCoQuanDieuTra')} checked={this.state.giaoCoQuanDieuTra}>
                  <div className="col-100 no-gutter mt5 pb5">
                    <h2 className="title-12 mb15">Chuyển cơ quan điều tra(Nếu có)</h2>
                    <div className="row pl10 pr10">
                      <DropDownChonCoQuanDieuTra className="col-25 mb0-18" label="Tên cơ quan" isValid={this.state.isValid} bindValidator={this} require selectedValue={this.state.coQuanDieuTra} onChange={this.onChange.bind(this, 'coQuanDieuTra')}/>
                      <InputNumber className="col-25 mb0-18" label="Số vụ" value={Number(this.state.soVuGiaoCoQuanDieuTra)} onChange={this.onChange.bind(this, 'soVuGiaoCoQuanDieuTra')}/>
                      <InputNumber className="col-25 mb0-18" label="Số đối tượng" value={Number(this.state.soDoiTuongGiaoCoQuanDieuTra)} onChange={this.onChange.bind(this, 'soDoiTuongGiaoCoQuanDieuTra')} maxLength={255}/>
                      <ShowIf condition={this.state.allowAttachGiaoCoQuanDieuTra}>
                        <div className="col-100 pt15">
                          <ContainerFileDinhKem onSave={this.state.onSave} phanLoaiQuyTrinh='GIAO_CO_QUAN_DIEU_TRA' label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.taiLieuVanThuGiaoCoQuanDieuTra} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
                        </div>
                      </ShowIf>
                    </div>
                  </div>

                  <div className="col-100 no-gutter pt5 pb15">
                    <span className="line-border"></span>
                  </div>

                  <div className="col-100 no-gutter">
                    <ShowIfCheck label="Khởi tố" onChange={this.handleCheck.bind(this, 'khoiTo')} checked={this.state.khoiTo}>
                      <div className="col-100 no-gutter mt5 pb20">
                        <h2 className="title-12 mb15">Khởi tố</h2>
                        <div className="row pl10 pr10">
                          <div className="col-50 no-gutter">
                            <InputNumber className="col-50 mb0-18" label="Số vụ" value={this.state.soVuBiKhoiTo} onChange={this.onChange.bind(this, 'soVuBiKhoiTo')}/>
                            <InputNumber className="col-50 mb0-18" label="Số đối tượng" value={this.state.soDoiTuongBiKhoiTo} onChange={this.onChange.bind(this, 'soDoiTuongBiKhoiTo')} maxLength={255}/>
                          </div>
                        </div>
                      </div>
                    </ShowIfCheck>
                  </div>
                </ShowIfCheck>
              </div>
            </div>
          </ShowIf>

          <ShowIf condition={this.state.allowAttach}>
            <div className="col-100 no-gutter pb5">
              <ContainerFileDinhKem onSave={this.state.onSave} bindValidator={this} data={this.state.listTaiLieuVanThuGiaiQuyetDon} dataShow={this.state.listTaiLieuVanThuGiaiQuyetDonView} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
            </div>
          </ShowIf>
        </div>

        <div className='col-100 no-gutter'>
          <div className='wrap-gqd-kqt'>
            <div className="box-bottom gqd-wrap col-100 mt20 pt30">
              <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
              <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this)}><span>Lưu tạm</span></Link>
              <ShowIf condition={this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET'}>
                <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.openDialog.bind(this, 'luuHoSo')}><span>Lưu hồ sơ</span></Link>
              </ShowIf>
              <ShowIf condition={this.state.ketQuaXLDGiaiQuyet == 'DOI_THOAI'}>
                <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.openDialog.bind(this, 'giaoDoiThoai')}><span>Chuyển đơn vị {lb1}</span></Link>
              </ShowIf>
              <ConfirmDialog open={this.state.openDialogLuuHoSo} onClose={this.closeDialog.bind(this, 'luuHoSo')} onSuccess={this.onSuccess.bind(this, 'luuHoSo')} title="Xác nhận lưu hồ sơ" content="Bạn có muốn lưu hồ sơ này?"/>
              <ConfirmDialog open={this.state.openDialogGiaoDoiThoai} onClose={this.closeDialog.bind(this, 'giaoDoiThoai')} onSuccess={this.onSuccess.bind(this, 'giaoDoiThoai')} title="Xác nhận" content={'Bạn có đồng ý chuyển đơn/vụ việc này cho ' + (this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo.ten : '' ) + ' lập dự thảo không?'}/>
            </div>
          </div>
        </div>

        <Dialog
        isOpen={this.state.open}
        onClose={this.closeDialogConfirm.bind(this)}
        title='Xác nhận'
        className="reception-dialog delete-dialog wrap-block"
        >
          <div className="pt-dialog-body">
            <p className="reception-dialog-text">Chọn "Đã có quyết định giải quyết" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?</p>
          </div>
          <div className="box-bottom col-100">
            <Link className="btn-action btn-close action-todo" onClick={this.closeDialogConfirm.bind(this)}><span>Không</span></Link>
            <Link className="btn-green" onClick={this.onSuccessDialogConfirm.bind(this)}><span>Đồng ý</span></Link>
          </div>
        </Dialog>
      </section>
    );
  }
}

LapDuThaoDonKhieuNaiCanBo.defaultProps = {
  ketQuaGiaiQuyetDon: [],
  validators: {
    formTaoDon: []
  }
}

let bindStateToProps = state => {
  return {
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  }
}

export default connect(bindStateToProps)(LapDuThaoDonKhieuNaiCanBo);



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-giai-quyet/chuyen-vien/LapDuThaoDonKhieuNaiCanBo.jsx